module.exports = __webpack_public_path__ + "static/media/top.74ab9d68.png";